import { useAutoneTranslation } from '@autone/translations';

const usePeakViewMetricTitles = () => {
  const { common } = useAutoneTranslation();

  return {
    seasonAndEvent: common.withCustomer(
      'peak-view.metric-titles.$season-and-event',
    ),
    firstSale: common('peak-view.metric-titles.first-sale'),
    lifeToDateSales: common('peak-view.metric-titles.life-to-date-sales'),
    department: common.withCustomer('peak-view.metric-titles.$department'),
    subDepartment: common.withCustomer(
      'peak-view.metric-titles.$sub-department',
    ),
    material: common('peak-view.metric-titles.material'),
    gender: common.withCustomer('peak-view.metric-titles.$gender'),
  };
};

export default usePeakViewMetricTitles;
